import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './CreateBillingAgreementAsDialog.styles.scss';
import cn from 'classnames';
import { RadioButton } from 'primereact/radiobutton';
import { ACTING_AS, AGREEMENT_TYPE } from '../../config/constants';

const CreateBillingAgreementAsDialog = ({
  visible,
  setVisible,
  onConfirm,
  agreementType,
}) => {
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState(ACTING_AS.SELLER);

  return (
    <Dialog
      onHide={() => setVisible(false)}
      className={cn(
        'rounded-4 overflow-hidden',
        styles.createBillingAgreementAsDialog,
      )}
      header={t('special_billing.are-you-applying-in-the-capacity-of')}
      visible={visible}
      footer={
        <>
          <Divider className="mb-4" />
          <div className="d-flex flex-row gap-4">
            <Button
              className="flex-grow-1"
              type="button"
              size="medium"
              label={t('common.next')}
              onClick={() => {
                onConfirm(selectedOption);
                setVisible(false);
              }}
            />
          </div>
        </>
      }
    >
      <div className={styles.submissionMessage}>
        <div className="d-flex align-items-center">
          <RadioButton
            name={'createAs'}
            value={ACTING_AS.SELLER}
            checked={selectedOption === ACTING_AS.SELLER}
            onClick={() => {
              setSelectedOption(ACTING_AS.SELLER);
            }}
          />
          <label className="mx-2">{t('special_billing.seller')}</label>
        </div>
        {agreementType === AGREEMENT_TYPE.SELF && (
          <div className="d-flex align-items-center">
            <RadioButton
              name={'createAs'}
              value={ACTING_AS.BUYER}
              checked={selectedOption === ACTING_AS.BUYER}
              onClick={() => {
                setSelectedOption(ACTING_AS.BUYER);
              }}
            />
            <label className="mx-2">{t('special_billing.buyer')}</label>
          </div>
        )}
        {agreementType === AGREEMENT_TYPE.THIRD && (
          <div className="d-flex align-items-center">
            <RadioButton
              name={'createAs'}
              value={ACTING_AS.THIRD}
              checked={selectedOption === ACTING_AS.THIRD}
              onClick={() => {
                setSelectedOption(ACTING_AS.THIRD);
              }}
            />
            <label className="mx-2">{t('special_billing.third')}</label>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default CreateBillingAgreementAsDialog;
